<div class="container-fluid">
  <div class="row ion-hide-lg-down ion-margin ion-padding">
    <div class="col col-md-8 col-md-offset-2 col-xl-6 col-offset-xl-3 search ion-text-left">
        <div class="search-item">
          <input class="ion-searchbar" id="search-input" [(ngModel)]="getSearch" type="search" placeholder="Keywords" required />
          <div class="error-search ion-padding" *ngIf="errorSearch">
            Please fill in this field.
          </div>
        </div>
        <div class="search-item">
          <select [(ngModel)]="getOption" id="search-option" required>
            <option value="" disabled selected>Select</option>
            <option>Gigs</option>
            <option>Jobs</option>
            <option>Volunteers</option>
            <option>Promote</option>
          </select>
          <div class="error-search ion-padding" *ngIf="errorOption">
            Please fill in this field.
          </div>
          <button class="button-solid button-tertiary button-round ion-no-margin" id="search-button" (click)="goToSearch()">Search</button>
        </div>
    </div>
  </div>
  <div class="row ion-hide-lg-up ion-margin ion-padding">
    <div class="col col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 ion-text-center mobile-search">
      <div class="search-item">
        <input class="ion-searchbar" [(ngModel)]="getSearch" id="mobile-search-input" type="search" placeholder="Keywords" required />
        <div class="error-search ion-padding" *ngIf="errorSearch">
          Please fill in this field.
        </div>
      </div>
      <div class="search-item">
        <select [(ngModel)]="getOption" id="mobile-search-option" required>
          <option value="" disabled selected>Select your option</option>
          <option>Gigs</option>
          <option>Jobs</option>
          <option>Volunteers</option>
          <option>Promote</option>
        </select>
        <div class="error-search ion-padding" *ngIf="errorOption">
          Please fill in this field.
        </div>
        <button class="button-large button-solid button-tertiary button-round button-block ion-no-margin" id="mobile-search-button" (click)="goToSearch()">Search</button>
      </div>
    </div>
  </div>
</div>